import { useEffect, useState } from 'react';
import { Link, Text } from '@dodilio/ui-design-lib';

/**
 * "Resend code", then a countdown before it can be asked again. `onResend`
 * says whether a code went out (a refusal starts no countdown). `coolingFrom`
 * starts it counting, for a page that has just sent one.
 */
export const ResendCode = ({ onResend, seconds = 60, coolingFrom = 0 }: {
    onResend: () => Promise<boolean>;
    seconds?: number;
    coolingFrom?: number;
}) => {
    const [left, setLeft] = useState(coolingFrom);
    const [sending, setSending] = useState(false);

    useEffect(() => {
        if (left <= 0) return;
        const id = window.setTimeout(() => setLeft((n) => n - 1), 1000);
        return () => window.clearTimeout(id);
    }, [left]);

    if (sending || left > 0) {
        return <Text size="2" color="gray" aria-live="polite">{sending ? 'Sending…' : `Resend in ${left}s`}</Text>;
    }
    return (
        <Link
            href="#"
            underline="always"
            size="2"
            onClick={async (e: React.MouseEvent) => {
                e.preventDefault();
                setSending(true);
                const sent = await onResend().catch(() => false);
                setSending(false);
                if (sent) setLeft(seconds);
            }}
        >
            Resend code
        </Link>
    );
};
